// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorPage_errorWrapper__2DMSc","icon":"ErrorPage_icon__2t3Bl","text":"ErrorPage_text__1SsyD","errorCode":"ErrorPage_errorCode__nksOS"};